<div class="ui-procedures-new">
    <h3 class="ui-procedures-new-title ui-title" mat-dialog-title>Nueva gestión</h3>
  
    <div class="ui-procedures-new-content" mat-dialog-content>
      <form class="ui-dialog" [formGroup]="formData">
        <div class="ui-form">
          <div class="ui-form-row">
            <mat-form-field class="ui-input">
              <mat-label>Área</mat-label>
              <mat-select formControlName="area" (selectionChange)="onAreaChange(this.formData.get('area')?.value)">
                <mat-option *ngFor="let item of areasData" [value]="item.id">{{item.name}}</mat-option>
              </mat-select>
              <mat-error *ngIf="formHasError('area', 'validate')">{{formHasError('area', 'message')}}</mat-error>
            </mat-form-field>
          </div>

          <div class="ui-form-row">
            <mat-form-field class="ui-input">
              <mat-label>Motivo</mat-label>
              <mat-select formControlName="reason">
                <mat-option *ngFor="let item of reasonsData" [value]="item.id">{{item.name}}</mat-option>
              </mat-select>
              <mat-error *ngIf="formHasError('reason', 'validate')">{{formHasError('reason', 'message')}}</mat-error>
            </mat-form-field>
          </div>
  
          <div class="ui-form-row">
            <mat-form-field class="ui-input">
              <mat-label>Comentarios</mat-label>
              <textarea matInput formControlName="message"></textarea>
              <mat-error *ngIf="formHasError('message', 'validate')">{{formHasError('message', 'message')}}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
    
    <div class="ui-procedures-new-actions" mat-dialog-actions>
      <button class="ui-button" mat-button (click)="onCancel()">Cancelar</button>
      <button class="ui-button" mat-button (click)="onSubmit()" color="primary" cdkFocusInitial>Generar</button>
    </div>
  </div>